import dayjs from "dayjs";
import { TFunction } from "i18next";

import { Text } from "@pentabd/ui";

import { ItemType } from "@type/inventory/stock/items";
import { StatusText } from "@components";

export const StockProductListDetailsTableColumn = (
  t: TFunction<"translation", undefined>,
  language: string | null,
) => {
  return [
    {
      id: 1,
      key: "procurement",
      name: t("INVENTORY_STOCK.ITEMS.TABLE.COLUMN.PROCUREMENT"),
      render: (procurement: string) => (
        <Text color="subtitle2" className="text-nowrap">
          {procurement ? procurement : "..."}
        </Text>
      ),
    },
    {
      id: 2,
      key: "unitInStock",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.ITEMS.TABLE.COLUMN.UNIT"),
      render: (unitInStock: number) => <StatusText amount={unitInStock} />,
    },
    {
      id: 3,
      key: "unitPrice",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.ITEMS.TABLE.COLUMN.PRICE"),
      render: (unitPrice: number) => (
        <Text color="subtitle2">{unitPrice ? unitPrice : "..."}</Text>
      ),
    },
    {
      id: 4,
      key: "warrantyStartDate",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.ITEMS.TABLE.COLUMN.WARRANTY"),
      render: (_: string, row: ItemType) => (
        <div className="d-flex gap-2">
          <Text color="subtitle2" component="p">
            {row.warrantyStartDate &&
              dayjs(row.warrantyStartDate).format("DD-MM-YYYY")}
          </Text>{" "}
          ~
          <Text color="warning" component="p">
            {row.warrantyEndDate &&
              dayjs(row.warrantyEndDate).format("DD-MM-YYYY")}
          </Text>
        </div>
      ),
    },
    {
      id: 5,
      key: "lotNo",
      name: t("INVENTORY_STOCK.ITEMS.TABLE.COLUMN.LOT_NO"),
      render: (lotNo: string) => (
        <Text color="subtitle2">{lotNo ? lotNo : "..."}</Text>
      ),
    },
    {
      id: 6,
      key: "purchaseDate",
      className: "text-nowrap",
      name: t("INVENTORY_STOCK.ITEMS.TABLE.COLUMN.PURCHASE_DATE"),
      render: (purchaseDate: string) => (
        <Text color="subtitle2">
          {purchaseDate ? dayjs(purchaseDate).format("DD/MM/YYYY") : "..."}
        </Text>
      ),
    },
  ];
};
